import { SpotStatus } from './RoomLayoutMap.types';

export type SpotTypeBreakdownSpot = {
  status: SpotStatus;
  spot_type_name?: string;
  spot_type_prefix?: string;
  spot_type_id?: string;
};

export type SpotTypeAvailability = {
  typeName: string;
  count: number;
};

function resolveSpotTypeName(spot: SpotTypeBreakdownSpot): string {
  const name = typeof spot.spot_type_name === 'string' ? spot.spot_type_name.trim() : '';
  if (name) return name;
  const prefix = typeof spot.spot_type_prefix === 'string' ? spot.spot_type_prefix.trim() : '';
  if (prefix) return prefix;
  const id = typeof spot.spot_type_id === 'string' ? spot.spot_type_id.trim() : '';
  if (id) return id;
  return 'Spot';
}

export function buildBookableSpotTypeBreakdown(
  spots: SpotTypeBreakdownSpot[]
): SpotTypeAvailability[] {
  const counts = new Map<string, number>();

  for (const spot of spots) {
    if (spot.status !== SpotStatus.BOOKABLE) continue;
    const typeName = resolveSpotTypeName(spot);
    counts.set(typeName, (counts.get(typeName) ?? 0) + 1);
  }

  return Array.from(counts.entries())
    .map(([typeName, count]) => ({ typeName, count }))
    .sort((a, b) => b.count - a.count || a.typeName.localeCompare(b.typeName));
}

/** Pass localized availability suffix from the host (e.g. "available"). */
export function formatBookableSpotTypeBreakdown(
  breakdown: SpotTypeAvailability[],
  availableSuffix = 'available'
): string | null {
  if (!breakdown.length) return null;
  const parts = breakdown.map(({ count, typeName }) => `${String(count)} ${typeName}`);
  return `${parts.join(', ')} ${availableSuffix}`;
}
